export function GeneralLifeEventsDetails() {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">General Life Event Details</h2>
      
      <div className="bg-white rounded-lg p-8 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Event Type */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Type of Event <span className="text-red-500">*</span>
            </label>
            <select className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200">
              <option value="">Select event type</option>
              <option value="achievement">Personal Achievement</option>
              <option value="life_change">Major Life Change</option>
              <option value="special_moment">Special Moment</option>
              <option value="personal_growth">Personal Growth</option>
              <option value="custom">Custom Life Event</option>
            </select>
          </div>

          {/* Event Title */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Event Title <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Give your event a title"
            />
          </div>

          {/* Date */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* Location */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Location
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Where did this event take place?"
            />
          </div>

          {/* Brief Description */}
          <div className="col-span-2 space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Brief Description <span className="text-red-500">*</span>
            </label>
            <textarea
              className="w-full h-32 p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Provide a brief overview of this life event"
            />
          </div>
        </div>
      </div>
    </div>
  )
} 